import { Injectable } from "@angular/core";
import { GraphQLService } from "./graphql.service";
import { HttpClient } from "@angular/common/http";
import { Product } from "../models/product.model";
import { Cart } from "../models/cart.model";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Voucher } from "../models/voucher.model";
import { TranslationBundle } from "../models/vouchers/translation_bundle.model";
import { CartItem } from "../models/cart_item.model";
import { BookPriceOffer } from "../models/vouchers/book_price_offer.model";

@Injectable()
export class CartService extends GraphQLService<Cart> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  addToCart(product: Product) {
    return this.push(`mutation { addToCart(productId: ${ product.id }) { ${ this.cartQuery() } }}`)
  }

  addTranslationBundleToCart(bundle: TranslationBundle, cartItems: CartItem[]) {
    const quantities: { id: number; amount: number }[] = []
    cartItems.forEach((item) => {
        if (item.product && item.product.id) {
          quantities.push({id: item.product.id, amount: item.amount || 1})
        }
      }
    )
    return this.push(`mutation { addTranslationBundleToCart(code: "${ bundle.code }", quantities: "${ JSON.stringify(quantities).replace(/\"/g, "\\\"") }") { ${ this.cartQuery() } }}`)
  }

  addBundleOfferToCart(voucher: Voucher | BookPriceOffer) {
    return this.push(`mutation { addBundleOfferToCart(code: "${ voucher.code }") { ${ this.cartQuery() } } }`)
  }

  addVoucherToCart(voucher: Voucher | BookPriceOffer) {
    return this.push(`mutation { addVoucherToCart(code: "${ voucher.code }") { ${ this.cartQuery() } } }`)
  }

  cart() {
    return this.find(`{ cart { ${ this.cartQuery() } } }`)
  }

  private cartQuery() {
    const currencyPricesQuery = `currencyPrices { currency exchangeRate netPrice }`
    const discountQry = `discount { amount currency { currency } percentage title }`
    const productQry = `product { id internalId priceNetto ${ currencyPricesQuery } productBook { isbn title subtitle } }`
    const voucherQry = `voucher { code isbn validUntil promotion quantity amount usedAmount availableAmount ${ discountQry } ${ productQry } ${ currencyPricesQuery }  }`
    const cartItemQry = `cartItems { id amount editable priceNetto ${ currencyPricesQuery } ${ productQry } ${ voucherQry } ${ discountQry } }`
    return `${ discountQry } ${ cartItemQry }`
  }

}
